var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}),_c(_vm.JComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }